Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Details2311737032",
  {"titleAndRole":"Details2311737032--titleAndRole","badgesSection":"Details2311737032--badgesSection","privacyAndMembers":"Details2311737032--privacyAndMembers","title":"Details2311737032--title","groupInfoItem":"Details2311737032--groupInfoItem","root":"Details2311737032--root"},
  "",
  2,
  "Details2311737032"
);

